<template>
  <div class="border">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/reports`;
    this.setLink += `/${this.id}/reports`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "dealers",
      setLink: "dealers",
      columns: [
        {
          key: "date",
          title: "Дата отчета",
        },
        {
          key: "gross_proceeds",
          title: "Валовая выручка",
          price: true,
        },
        {
          key: "cost_price",
          title: "Сумма себестоимости проданного товара",
          price: true,
        },
        {
          key: "balance_at_cost",
          title: "Остаток по себестоимости",
          price: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
